var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { classNames, useEffect, useMutation } from 'libs/react';
import { useState } from 'libs/react';
import { Button } from 'components/Button';
import { React, Suspense } from 'libs/react';
import { lazy } from 'react';
import { Text } from 'components/Text';
import { FormInput } from 'components/form/FormInput';
import { FormPhone } from 'components/form/FormPhone';
import { FormField } from 'components/form/FormField';
import { FormGroup } from 'components/form/FormGroup';
import { FormGoogleAutocompleteInput } from 'components/form/FormGoogleAutocompleteInput';
import { DateTime, toFormattedDate } from 'components/DateTime';
import { ModalStripe } from './modal/ModalStripe';
import { ModalMewsPayment } from './modal/ModalMewsPayment';
import { ModalSignature } from './modal/ModalSignature';
import { GenerateDealMutation } from 'graphql/Deal/mutations/GenerateDealMutation';
import { RefuseDealMutation } from 'graphql/Deal/mutations/RefuseDealMutation';
import { useAlert } from 'components/alert/AlertStack';
import { useModal } from 'components/modal/ModalStack';
import { Confirm } from 'components/confirm/Confirm';
import './QuoteApproval.scss';
import { DealPublicQuery } from 'graphql/Deal/queries/DealPublicQuery';
/*
 * Loaded when opened: the terms editor brings Quill, which the quote page does
 * not need until then.
 */
const ModalViewTerms = lazy(() => import('modules/deal/components/section/terms/modal/ModalViewTerms').then((m) => ({ default: m.ModalViewTerms })));
/**
 * @component QuoteApproval
 * @since 1.0.0
 */
export function QuoteApproval(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
    const { processing, data, openStripeModal, openMewsPaymentModal, setSignatureData, signatureData, validityPeriodDate, hasPaymentProcess, hasDeposit, isOrder, isApprovedOverride, host, contactFields } = props;
    const showContactFields = !!data.directSale &&
        (host === 'estrimont.centralio.com' || host === 'axhotel.centralio.com');
    const showAddress = showContactFields && !!(contactFields === null || contactFields === void 0 ? void 0 : contactFields.includes('ADDRESS'));
    const [openModal, setOpenModal] = useState(false);
    const [isChecked, setIsChecked] = useState(isOrder ? true : false);
    const [isOpenStripeModal, setOpenStripeModal] = useState(openStripeModal);
    const [isOpenMewsPaymentModal, setOpenMewsPaymentModal] = useState(false);
    const isMewsPayment = ((_a = data.paymentIntegration) === null || _a === void 0 ? void 0 : _a.type) === 'mews_payment';
    const [contactFirstName, setContactFirstName] = useState('');
    const [contactLastName, setContactLastName] = useState('');
    const [contactEmail, setContactEmail] = useState((_d = (_c = (_b = data.contact) === null || _b === void 0 ? void 0 : _b.primaryEmail) === null || _c === void 0 ? void 0 : _c.email) !== null && _d !== void 0 ? _d : '');
    const [contactPhone, setContactPhone] = useState('');
    const [address, setAddress] = useState('');
    const [autocompleteData, setAutocompleteData] = useState({
        civicNumber: '',
        road: '',
        apartment: '',
        city: '',
        province: '',
        postalcode: '',
        country: '',
        latitude: null,
        longitude: null
    });
    const onLocationSelected = (location) => {
        setAutocompleteData({
            civicNumber: location.civicNumber,
            road: location.road,
            apartment: location.apartment,
            city: location.city,
            province: location.province,
            postalcode: location.postalcode,
            country: location.country,
            latitude: location.latitude,
            longitude: location.longitude
        });
        setAddress(location.civicNumber +
            ' ' +
            location.road +
            (location.apartment ? ' ' + location.apartment : '') +
            ', ' +
            location.city +
            ', ' +
            location.province +
            ', ' +
            location.postalcode +
            ' ' +
            location.country);
    };
    const contactFieldsValid = !showContactFields ||
        (contactFirstName.trim() !== '' &&
            contactLastName.trim() !== '' &&
            contactEmail.trim() !== '' &&
            contactPhone.trim() !== '' &&
            (!showAddress || ((_e = autocompleteData.civicNumber) === null || _e === void 0 ? void 0 : _e.trim()) !== ''));
    const [openSignatureModal, setOpenSignatureModal] = useState(false);
    const alert = useAlert();
    const modal = useModal();
    const [downloadPDF, { loading: downloadingPDF }] = useMutation(GenerateDealMutation);
    const [refuseDeal, { loading: refusingDeal }] = useMutation(RefuseDealMutation);
    const approbations = (data === null || data === void 0 ? void 0 : data.approbations) ? [...data.approbations] : [];
    const isAgreement = data.type === 'AGREEMENT';
    const isApproved = isOrder
        ? (isApprovedOverride !== null && isApprovedOverride !== void 0 ? isApprovedOverride : false)
        : (((_f = approbations === null || approbations === void 0 ? void 0 : approbations.sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))[0]) === null || _f === void 0 ? void 0 : _f.state) === 'ACCEPTED' &&
            data.status === 'ACCEPTED') ||
            data.status === 'WON' ||
            data.status === 'SIGNED';
    const signatureEligible = isOrder
        ? true
        : isAgreement
            ? data.status !== 'INACTIVE'
            : data.status !== 'INACTIVE' && data.priceDisplay !== 'NONE';
    const dealCanBeSigned = isAgreement || ((_g = data.canBeSigned) !== null && _g !== void 0 ? _g : true);
    const canAcceptSubmission = dealCanBeSigned && signatureEligible;
    const termsAndConditions = (_k = (_j = (_h = data === null || data === void 0 ? void 0 : data.translations) === null || _h === void 0 ? void 0 : _h.find((translation) => translation.language.code === data.language)) === null || _j === void 0 ? void 0 : _j.termsAndConditions) !== null && _k !== void 0 ? _k : '';
    // Check if client can refuse deal
    const clientCanRefuseDeal = ((_p = JSON.parse((_o = (_m = (_l = data === null || data === void 0 ? void 0 : data.configurationFields) === null || _l === void 0 ? void 0 : _l.find((conf) => conf.fieldKey === 'CLIENT_CAN_REFUSE_DEAL')) === null || _m === void 0 ? void 0 : _m.value) !== null && _o !== void 0 ? _o : '{}')) === null || _p === void 0 ? void 0 : _p.value) === 'TRUE';
    const activePayment = hasDeposit
        ? (_q = data === null || data === void 0 ? void 0 : data.payments) === null || _q === void 0 ? void 0 : _q.find((p) => p.status === 'ACTIVE' && p.isDeposit === true)
        : (_r = data === null || data === void 0 ? void 0 : data.payments) === null || _r === void 0 ? void 0 : _r.find((p) => p.status === 'ACTIVE');
    const isDepositPayment = hasDeposit && (activePayment === null || activePayment === void 0 ? void 0 : activePayment.isDeposit) === true;
    useEffect(() => {
        if (openStripeModal) {
            setOpenStripeModal(true);
        }
    }, [openStripeModal]);
    useEffect(() => {
        if (openMewsPaymentModal) {
            setOpenMewsPaymentModal(true);
        }
    }, [openMewsPaymentModal]);
    /**
     * @function onCheckboxChange
     * @since 1.0.0
     * @hidden
     */
    const onCheckboxChange = () => {
        setIsChecked(!isChecked);
        if (openModal) {
            setOpenModal(false);
        }
    };
    /**
     * @function onPressTermsAndConditions
     * @since 1.0.0
     * @hidden
     */
    const onPressTermsAndConditions = () => {
        setOpenModal(true);
    };
    /**
     * @function onCloseTermsAndConditions
     * @since 1.0.0
     * @hidden
     */
    const onCloseTermsAndConditions = () => {
        setOpenModal(false);
    };
    /**
     * @function onSignature
     * @since 1.0.0
     * @hidden
     */
    const onSignature = () => {
        setOpenSignatureModal(true);
    };
    /**
     * @function onSignatureCompleted
     * @since 1.0.0
     * @hidden
     */
    const onSignatureCompleted = (signatureData) => __awaiter(this, void 0, void 0, function* () {
        setOpenSignatureModal(false);
        if (signatureData.signatureBase64) {
            setSignatureData(signatureData);
        }
        else {
            setSignatureData(null);
        }
    });
    /**
     * @function onDownloadPDF
     * @since 1.0.0
     * @hidden
     */
    const onDownloadPDF = () => __awaiter(this, void 0, void 0, function* () {
        var _0, _1;
        try {
            const response = yield downloadPDF({
                variables: {
                    input: { id: data.id }
                }
            });
            if ((_1 = (_0 = response.data) === null || _0 === void 0 ? void 0 : _0.generateDealPdf) === null || _1 === void 0 ? void 0 : _1.filepath) {
                window.open(response.data.generateDealPdf.filepath, '_blank');
            }
        }
        catch (error) {
            console.error('Error downloading PDF:', error);
        }
    });
    /**
     * @function executeRefuseDeal
     * @since 1.0.0
     * @hidden
     */
    const executeRefuseDeal = () => __awaiter(this, void 0, void 0, function* () {
        try {
            yield refuseDeal({
                variables: {
                    input: { id: data.id }
                },
                refetchQueries: [
                    {
                        query: DealPublicQuery,
                        variables: {
                            input: { id: data.id }
                        }
                    }
                ]
            });
            alert.present({
                title: React.createElement("p", null, t('The quote has been refused.'))
            });
        }
        catch (err) {
            const error = err;
            alert.present({ error });
        }
    });
    /**
     * @function onRefuseDeal
     * @since 1.0.0
     * @hidden
     */
    const onRefuseDeal = () => {
        modal.present({
            style: 'dialog',
            title: t('Confirm'),
            picto: 'check',
            modal: (React.createElement(Confirm, { title: t('Refuse the quote?'), infos: t('Are you sure you want to refuse this quote? This action cannot be undone.'), acceptText: t('Refuse'), refuseText: t('Cancel'), onAccept: executeRefuseDeal }))
        });
    };
    useEffect(() => {
        setIsChecked(isOrder ? true : isApproved);
    }, [isApproved, isOrder]);
    return (React.createElement("div", { id: "approval", className: "quote-approval" },
        React.createElement("div", { className: "quote-approval-heading" },
            !data.directSale ? t('Approval') : t('Confirmation'),
            !isOrder && data.status === 'LOST' ? (React.createElement("span", { className: "quote-approval-validity quote-approval-validity--refused" },
                React.createElement(Text, { value: t('Quote refused') }))) : !isOrder &&
                validityPeriodDate &&
                validityPeriodDate > new Date() &&
                !data.directSale ? (React.createElement("span", { className: "quote-approval-validity" },
                React.createElement(Text, { value: t('Quote valid until') }),
                ' ',
                React.createElement(DateTime, { value: validityPeriodDate, y: "numeric", m: "numeric", d: "numeric" }))) : !isOrder && validityPeriodDate && !data.directSale ? (React.createElement("span", { className: "quote-approval-validity quote-approval-validity--expired" },
                React.createElement(Text, { value: t('Quote expired on') }),
                ' ',
                React.createElement(DateTime, { value: validityPeriodDate, y: "numeric", m: "numeric", d: "numeric" }))) : null),
        !isOrder && data.status === 'LOST' ? (React.createElement("div", { className: "quote-approval-refused" },
            React.createElement("div", { className: "quote-approval-refused-message" },
                React.createElement(Text, { className: "quote-approval-refused-title", value: t('This quote has been refused') }),
                React.createElement(Text, { className: "quote-approval-refused-info", value: t('The quote has been refused and is no longer available for approval.') })),
            React.createElement(Button, { picto: "xmark-circle", size: "large", label: t('Refused'), className: "quote-approval-button-refused", disabled: true }))) : (React.createElement(React.Fragment, null,
            showContactFields && !isApproved && (React.createElement(React.Fragment, null,
                React.createElement(Text, { value: t('Step 1: Enter your contact details'), className: "quote-approval-contact-heading" }),
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormInput, { label: t('First name'), name: "firstName", required: true, placeholder: t('Enter your first name'), onChange: (value) => setContactFirstName(value) })),
                    React.createElement(FormField, null,
                        React.createElement(FormInput, { label: t('Last name'), name: "lastName", required: true, placeholder: t('Enter your last name'), onChange: (value) => setContactLastName(value) }))),
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormInput, { label: t('Email'), name: "approvalEmail", required: true, value: contactEmail, placeholder: t('Enter your email address'), onChange: (value) => setContactEmail(value) })),
                    React.createElement(FormField, null,
                        React.createElement(FormPhone, { label: t('Phone'), name: "approvalPhone", required: true, placeholder: t('Enter your phone number'), onChange: (value) => setContactPhone(value) }))),
                showAddress && (React.createElement(React.Fragment, null,
                    React.createElement(FormGroup, null,
                        React.createElement(FormField, null,
                            React.createElement(FormGoogleAutocompleteInput, { name: "approvalAutocomplete", label: t('Address'), placeholder: t('Enter address'), onLocationSelected: onLocationSelected, value: address, required: true }))),
                    React.createElement(FormGroup, null,
                        React.createElement(FormInput, { type: "hidden", name: "approvalCivicNumber", optional: true, value: autocompleteData.civicNumber }),
                        React.createElement(FormInput, { type: "hidden", name: "approvalRoad", optional: true, value: autocompleteData.road }),
                        React.createElement(FormInput, { type: "hidden", name: "approvalApartment", optional: true, value: autocompleteData.apartment }),
                        React.createElement(FormInput, { type: "hidden", name: "approvalCity", optional: true, value: autocompleteData.city }),
                        React.createElement(FormInput, { type: "hidden", name: "approvalProvince", optional: true, value: autocompleteData.province }),
                        React.createElement(FormInput, { type: "hidden", name: "approvalPostalcode", optional: true, value: autocompleteData.postalcode }),
                        React.createElement(FormInput, { type: "hidden", name: "approvalCountry", optional: true, value: autocompleteData.country }),
                        React.createElement(FormInput, { type: "hidden", name: "approvalLatitude", optional: true, value: (_s = autocompleteData.latitude) === null || _s === void 0 ? void 0 : _s.toFixed(6) }),
                        React.createElement(FormInput, { type: "hidden", name: "approvalLongitude", optional: true, value: (_t = autocompleteData.longitude) === null || _t === void 0 ? void 0 : _t.toFixed(6) })))))),
            !isOrder && (React.createElement("div", { className: "quote-approval-terms" },
                React.createElement(Text, { value: showContactFields
                        ? t('Step 2: Read and accept the terms and conditions')
                        : t('Step 1: Read and accept the terms and conditions') }),
                React.createElement(Button, { style: "outline", picto: "book", size: "large", label: t('Terms and Conditions'), onPress: onPressTermsAndConditions }),
                openModal && (React.createElement(Suspense, { fallback: null },
                    React.createElement(ModalViewTerms, { accountTerm: data.accountTerm, term: data.term, termsAndConditions: termsAndConditions, onClose: onCloseTermsAndConditions, onCheckboxChange: onCheckboxChange, isChecked: isChecked, isApproved: isApproved, isFromApproval: true }))),
                React.createElement("div", { className: "quote-approval-terms--checkbox" },
                    React.createElement("input", { name: "terms", id: "terms", type: "checkbox", required: true, checked: isChecked, onChange: onCheckboxChange, disabled: isApproved }),
                    React.createElement("label", { htmlFor: "terms", className: `${isApproved ? 'disabled' : ''}` }, isApproved
                        ? t('Accepted on') +
                            ' ' +
                            (approbations[0]
                                ? toFormattedDate((_u = approbations[0].createdAt) !== null && _u !== void 0 ? _u : '', {
                                    y: 'numeric',
                                    m: 'numeric',
                                    d: 'numeric',
                                    hh: 'numeric',
                                    mm: 'numeric',
                                    ss: 'numeric',
                                    time: true
                                })
                                : 'N/A')
                        : t('I have read and accept the Terms and Conditions'))))),
            React.createElement("div", { className: "quote-approval-signature-container" }, data.directSale &&
                (!isApproved || (isApproved && !data.orderIn)) ? (React.createElement("div", null,
                React.createElement(Text, { value: showContactFields
                        ? t('Step 3: Confirm acceptance and Pay')
                        : t('Step 2: Confirm acceptance and Pay') }),
                data.stage === 'PENDING_PAYMENT' ? (React.createElement(Button, { picto: "money-check-dollar", className: "quote-approval-button", size: "large", label: t('Accept and Pay'), disabled: processing || !isChecked, processing: processing, onPress: () => {
                        if (!contactFieldsValid) {
                            alert.present({
                                title: (React.createElement("p", null, t('Please fill in all contact details before proceeding.')))
                            });
                            return;
                        }
                        if (isMewsPayment) {
                            setOpenMewsPaymentModal(true);
                        }
                        else {
                            setOpenStripeModal(true);
                        }
                    } })) : (React.createElement(Button, { picto: "money-check-dollar", className: "quote-approval-button", size: "large", label: t('Accept and Pay'), disabled: processing || !isChecked, processing: processing, submit: true })))) : data.directSale &&
                isApproved &&
                data.orderIn ? (React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement(Text, { value: t('Step 2: Confirm acceptance and Pay') }),
                    React.createElement(Button, { picto: "circle-check", size: "large", label: t('Approved'), className: "quote-approval-button-approval-sent", disabled: true })),
                React.createElement("div", null,
                    React.createElement(Text, { value: t('Step 3: Download Order Confirmation') }),
                    React.createElement(Button, { picto: "file-pdf", size: "large", label: t('Download'), className: "quote-approval-button-approval-download", onPress: () => {
                            window.open(`/orders/confirmation/${data.id}`, '_blank');
                        } })))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "quote-approval-signature-head" },
                    React.createElement("div", { className: "quote-approval-signature-title" },
                        React.createElement(Text, { value: isOrder
                                ? t('Step 1: Sign the manufacturing list')
                                : t('Step 2: Sign the quote') }),
                        signatureData && !isApproved && dealCanBeSigned && (React.createElement(Button, { style: "outline", picto: "pen", size: "small", label: t('Edit'), onPress: () => setOpenSignatureModal(true) })))),
                React.createElement("div", { className: classNames([
                        'quote-approval-signature',
                        {
                            'quote-approval-signature--active': isChecked && signatureEligible && dealCanBeSigned
                        }
                    ]) }, !dealCanBeSigned ? (React.createElement("div", { className: "quote-approval-no-signature" },
                    React.createElement(Text, { value: t('Signature is not enabled at the moment') }))) : !isApproved && signatureEligible && !signatureData ? (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: classNames([
                            'quote-approval-signature-placeholder'
                        ]) },
                        React.createElement(Button, { style: "primary", picto: "signature", size: "large", label: t('Sign'), onPress: onSignature, disabled: signatureEligible && !isChecked })))) : signatureData && signatureEligible ? (React.createElement("div", { className: "quote-approval-signature-signed" },
                    React.createElement("img", { src: signatureData.signatureBase64 }),
                    React.createElement("div", { className: "quote-approval-signature-signed--info" },
                        React.createElement(Text, { value: signatureData.firstName +
                                ' ' +
                                signatureData.lastName }),
                        React.createElement(Text, { value: signatureData.email }),
                        React.createElement(Text, { value: toFormattedDate((_v = signatureData.date) !== null && _v !== void 0 ? _v : '', {
                                y: 'numeric',
                                m: 'numeric',
                                d: 'numeric',
                                hh: 'numeric',
                                mm: 'numeric',
                                ss: 'numeric',
                                time: false
                            }) })))) : (React.createElement("div", { className: "quote-approval-no-signature" },
                    React.createElement(Text, { value: t('Signature inactive') })))),
                dealCanBeSigned && signatureEligible && (React.createElement("div", { className: "quote-approval-text-signature" }, t('By signing this document with an electronic signature, I agree that such signature will be as valid as handwritten signature to the extent allowed by local law.'))),
                React.createElement("div", null, !isApproved ? (React.createElement(React.Fragment, null,
                    canAcceptSubmission && hasPaymentProcess ? (React.createElement(React.Fragment, null,
                        React.createElement(Text, { value: isDepositPayment
                                ? t('Step 3: Confirm acceptance and Pay Deposit')
                                : t('Step 3: Confirm acceptance and Pay') }),
                        React.createElement(Button, { picto: "money-check-dollar", className: "quote-approval-button", size: "large", label: isDepositPayment
                                ? t('Accept and Pay Deposit')
                                : t('Accept and Pay'), disabled: processing || !signatureData, processing: processing, submit: true }))) : canAcceptSubmission ? (React.createElement(React.Fragment, null,
                        React.createElement(Text, { value: isOrder
                                ? t('Step 2: Approve')
                                : t('Step 3: Confirm acceptance') }),
                        React.createElement(Button, { picto: "circle-check", className: "quote-approval-button", size: "large", label: isOrder ? t('Approve') : t('Accept'), disabled: processing || !signatureData, processing: processing, submit: true }))) : null,
                    !isOrder &&
                        !isAgreement &&
                        clientCanRefuseDeal &&
                        !data.directSale &&
                        data.status !== 'LOST' &&
                        data.status !== 'WON' &&
                        data.status !== 'SIGNED' &&
                        data.status !== 'ACCEPTED' && (React.createElement(React.Fragment, null,
                        React.createElement(Button, { picto: "xmark-circle", className: "quote-approval-button quote-approval-button--refuse", size: "large", style: "outline", label: t('Refuse'), disabled: refusingDeal, processing: refusingDeal, onPress: onRefuseDeal }))))) : (React.createElement(React.Fragment, null,
                    React.createElement(Button, { picto: "circle-check", size: "large", label: t('Accepted'), className: "quote-approval-button-approval-sent" }),
                    data.canGeneratePDF && (React.createElement(Button, { picto: "file-pdf", size: "large", label: t('Download'), className: "quote-approval-button-approval-download", disabled: downloadingPDF, processing: downloadingPDF, onPress: () => {
                            onDownloadPDF();
                        } })))))))))),
        isOpenStripeModal && (React.createElement(ModalStripe, { deal: data, onClose: () => setOpenStripeModal(false), onAlreadyPaid: () => {
                window.location.href = `/interactive-quote/${data.id}?paymentSuccess=true`;
            }, directSale: !!data.directSale, hasDeposit: isDepositPayment, firstName: showContactFields ? contactFirstName : undefined, lastName: showContactFields ? contactLastName : undefined, phone: showContactFields ? contactPhone : undefined, location: showAddress && autocompleteData.civicNumber
                ? {
                    civicNumber: autocompleteData.civicNumber,
                    road: autocompleteData.road,
                    apartment: autocompleteData.apartment,
                    city: autocompleteData.city,
                    province: autocompleteData.province,
                    postalcode: autocompleteData.postalcode,
                    country: autocompleteData.country,
                    latitude: (_w = autocompleteData.latitude) !== null && _w !== void 0 ? _w : undefined,
                    longitude: (_x = autocompleteData.longitude) !== null && _x !== void 0 ? _x : undefined,
                    billing: true,
                    shipping: true,
                    primary: true
                }
                : undefined })),
        isOpenMewsPaymentModal && (React.createElement(ModalMewsPayment, { deal: data, dealPaymentId: activePayment === null || activePayment === void 0 ? void 0 : activePayment.id, currency: (_z = (_y = data.currency) === null || _y === void 0 ? void 0 : _y.code) !== null && _z !== void 0 ? _z : 'CAD', onClose: () => setOpenMewsPaymentModal(false) })),
        openSignatureModal && (React.createElement(ModalSignature, { deal: data, onClose: () => {
                setOpenSignatureModal(false);
            }, onSignatureCompleted: onSignatureCompleted, signatureData: signatureData }))));
}
